import { getAnswer, postAnswer } from "@/api/api";

export default {
  data() {
    return {
      finished: false,
      loading: false,
      answers: [],
    };
  },
  computed: {
    stepType() {
      if (this.$route.name === "guided-lesson") {
        return "TEACH_EXERCISE";
      }
      return "GRAMMAR_EXERCISE";
    },
  },
  methods: {
    onReset() {
      this.answers = this.questions.map((question) => ({
        content: "",
        question: question.uuid,
        student: this.student.email,
      }));
      this.finished = false;
      this.$emit("reset");
    },
    async onFinish() {
      if (!this.finished) {
        this.loading = true;

        // Post all answers in parallel
        const answerPromises = this.answers.map(async (element) => {
          const response = await postAnswer(element);
          return response ? response.data : element;
        });

        // Wait for all answers to be posted
        this.answers = await Promise.all(answerPromises);

        this.finished = true;
        this.loading = false;
      }
      this.$emit("finished");
    },
    async create() {
      this.answers = [];
      this.loading = true;

      // Fetch all answers in parallel
      const answerPromises = this.questions.map(async (element) => {
        const response = await getAnswer({
          question__uuid: element.uuid,
          student__email: this.student.email,
        });

        if (response && response.data.count) {
          return response.data.results[0];
        } else {
          return {
            question: element.uuid,
            student: this.student.email,
            content: "",
          };
        }
      });

      // Wait for all answers to be fetched
      this.answers = await Promise.all(answerPromises);

      if (this.answers[0] && this.answers[0].uuid) {
        this.finished = true;
        this.$emit("already-finished");
      }
      if (this.extraCreate) this.extraCreate();
      this.loading = false;
    },
  },
  async created() {
    this.create();
  },
  watch: {
    questions() {
      this.create();
    },
  },
};
